<mat-drawer-container
  class="base"
  [hasBackdrop]="isMobile()"
  autosize
>
  <mat-drawer
    class="base__drawer"
    [mode]="isMobile() ? 'over' : 'side'"
    [opened]="sidebarOpened()"
    (closedStart)="sidebarOpened.set(false)"
  >
    <aside class="sb">
      <!-- Brand -->
      <div class="sb__brand">
        <img
          *ngIf="!disableNavigation && companyData?.logo"
          class="sb__logo"
          [src]="backendUrl + companyData.logo"
          alt="{{ companyData.companyName }}"
        />
        <div class="sb__name">{{ companyData?.companyName }}</div>
      </div>

      <!-- Navigation groups -->
      <ng-container *ngFor="let group of navigationGroups">
        <div class="sb__group-title" *ngIf="group.titleKey">
          {{ group.titleKey | transloco }}
        </div>
        <nav class="sb__list">
          <a
            class="sb__item"
            *ngFor="let item of group.items"
            [ngClass]="{
              'sb__item--active': activeItem() === item,
              'sb__item--disabled': disableNavigation
            }"
            (click)="onNavItemClick(item)"
          >
            <mat-icon fontSet="material-icons-round">{{ item.icon }}</mat-icon>
            {{ item.translation | transloco }}
            <span
              class="sb__item-badge"
              *ngIf="item.location === 'transactions' && unreadCount() > 0"
            >
              {{ unreadCount() }}
            </span>
          </a>
        </nav>
      </ng-container>

      <!-- Footer -->
      <div class="sb__footer">
        <div class="sb__meta">
          <span>v1.1.0</span>
          <span *ngIf="!isProdVersion" class="sb__server-status">
            TEST server
          </span>
        </div>
      </div>
    </aside>
  </mat-drawer>

  <mat-drawer-content class="base__main">
    <!-- Topbar -->
    <header class="tb">
      <button
        class="tb__icon-btn"
        *ngIf="isMobile()"
        (click)="toggleSidebar()"
      >
        <mat-icon fontSet="material-icons-round">menu</mat-icon>
      </button>
      <div class="tb__actions">
        <button
          class="tb__icon-btn"
          [ngClass]="{ 'tb__icon-btn--dot': unreadCount() > 0 }"
          [matTooltip]="'layout.notificationsTooltip' | transloco"
          (click)="router.navigate(['/transactions'])"
        >
          <mat-icon fontSet="material-icons-round">notifications_none</mat-icon>
        </button>
        <button
          class="tb__icon-btn"
          (click)="openHelp()"
          [matTooltip]="'layout.help' | transloco"
        >
          <mat-icon fontSet="material-icons-round">help_outline</mat-icon>
        </button>

        <div class="tb__user">
          <div class="tb__user-avatar">{{ getUserInitials() }}</div>
          <div class="tb__user-id">
            <strong>{{ getUserFirstName() }}</strong>
            <span>{{ getUserRoleKey() | transloco }}</span>
          </div>
          <button
            class="tb__logout"
            (click)="logout()"
            [matTooltip]="'layout.logout' | transloco"
          >
            <mat-icon fontSet="material-icons-round">logout</mat-icon>
          </button>
        </div>
      </div>
    </header>

    <!-- Page canvas -->
    <div class="canvas">
      <app-backoffice-info *ngIf="!disableNavigation"></app-backoffice-info>
      <router-outlet></router-outlet>
    </div>
  </mat-drawer-content>
</mat-drawer-container>
